import { KampaayDataProvider } from 'services/api/dataProvider'
import { DrinkSection } from 'services/api/entities/catalog/sections/drinkSections'
import { parseCsvFields } from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'

export const drinksections: EntityDescriptor<DrinkSection> = {
  headers: ['ID', 'Name'],
  format: (_dataProvider?: KampaayDataProvider) => (record) => ({
    ID: record.id,
    ...parseCsvFields({ Name: record.name }),
  }),
}
